import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { ReestrListDto } from '../../dto/reestr/ReestrLIstDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteReestr = async (dto: ReestrListDto) => {
  const params: IApiParams = {
    url: '/reestr/deleteInfo.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', dto);
};
